<template>
  <div>
    <div
      class="btn btn-sm btn-outline-color2 px-3 hover-color-white favorite-button"
      :class="{ disabled: !target }"
      v-b-modal="'share-' + type + '-' + target.id"
    >
      <div class="d-flex justify-content-between align-items-center ">
        <span class="text-color2 font-size-small nowrap" title="Compartilhar publicação">
          <i class="fa fa-share-alt"></i>
        </span>
      </div>
    </div>
    <ShareModal
      :type="type"
      :target="target"
      :modalId="'share-' + type + '-' + target.id"
    />
  </div>
</template>

<script>

import ShareModal from '@/components/share/ShareModal.vue'

export default {
  name: 'ShareTag',
  props: ['target', 'type'],
  components: {
    ShareModal
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.item {
  height: 56px;
}

.hover-color-white{
  &:hover, &:focus, &:active{
    span{
      color: #fff;
    }
  }
}
</style>
